import { render } from "./TrulyEmptyLayout.vue?vue&type=template&id=b9905e60&ts=true"
import script from "./TrulyEmptyLayout.vue?vue&type=script&lang=ts"
export * from "./TrulyEmptyLayout.vue?vue&type=script&lang=ts"

import "./TrulyEmptyLayout.vue?vue&type=style&index=0&id=b9905e60&lang=scss"

import exportComponent from "/home/node/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__